import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';

export interface Props {
  logo: string;
  homeRoute?: string;
}

export const HeaderLogo = ({ logo, homeRoute = '/' }: Props) => {
  return (
    <Wrapper>
      <Link to={homeRoute}>
        <HeaderLogoComponent src={logo} alt="Logo" />
      </Link>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  max-width: ${rem(220)};
  max-height: ${rem(96)};

  ${({ theme }) => theme.mediab.l925`
    max-width: ${rem(176)};
  `}
`;

const HeaderLogoComponent = styled.img`
  width: 100%;
  height: 100%;
`;
